import { NextSeo } from 'next-seo';

//screens
import { Default } from '@/screens/ThankYou/Default';

export default function Main() {
  return (
    <>
      <NextSeo nofollow={true} noindex={true} title="Thank You | Loadsmart" />

      <Default />
    </>
  );
}
